__turbopack_context__.v({
  "inBox": "LatestNewsBoxCluster-module-scss-module__o4djnG__inBox",
  "latestNewsBoxContainer": "LatestNewsBoxCluster-module-scss-module__o4djnG__latestNewsBoxContainer",
  "separator": "LatestNewsBoxCluster-module-scss-module__o4djnG__separator",
});
